module.exports = __webpack_public_path__ + "img/rang4.75aedef2.png";